import Img from 'components/common/Img'
import './style.styl'

export function SecurityWarning({
  text = 'Não se preocupe, todos os dados enviados são confidenciais',
}) {
  return (
    <div className="security-warning">
      <Img
        src="images/bb/identity-proof/shield-icon.svg"
        alt="Ícone de um escudo na cor cinza"
      />
      <p>{text}</p>
    </div>
  )
}
